<div *ngIf="section && visible" [nzBordered]="bordered" [id]="code">
  <ng-container [ngSwitch]="section?.customAttributes?.displayType">
    <ng-container *ngSwitchCase="'tabbed'">
      <nz-tabset [nzTabPosition]="section?.customAttributes?.tabLocation ?? 'left'" nzType="line">
        <ng-container *ngFor="let subSection of section?.subSections">
          <nz-tab *ngIf="subSection.visible" [nzTitle]="subSection.subsectionTitle"
            (nzClick)="section?.activateSubSection(subSection.subSectionCode)">
            <app-subsection *ngIf="subSection?.visible" [subSection]="subSection"
              [layout]="layout" [showHeader]=false></app-subsection>
          </nz-tab>
        </ng-container>
      </nz-tabset>
    </ng-container>

    <ng-container *ngSwitchCase="'accordion'">
      <ngb-accordion #acc="ngbAccordion">
        <ngb-panel id="toggle-1" [title]="section?.title">
          <ng-template ngbPanelContent>
            <ng-container *ngFor="let subSection of section?.subSections">
              <app-subsection *ngIf="subSection?.visible" [subSection]="subSection"
                [layout]="layout" [showHeader]="showSubsectionHeaders"></app-subsection>
            </ng-container>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <h4 *ngIf="showHeader" nz-typography><strong>{{section?.title}}</strong></h4>
      <ng-container *ngFor="let subSection of section?.subSections">
        <app-subsection *ngIf="subSection?.visible" [subSection]="subSection"
          [layout]="layout" [showHeader]="showSubsectionHeaders"></app-subsection>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
